import WebFont from "webfontloader";

WebFont.load({
  google: {
    families: ["Nunito:400,400i,700&display=swap"]
  }
});
